module.exports = __webpack_public_path__ + "static/media/SnapQR.6c66878d.png";